module.exports = __webpack_public_path__ + "img/experienceing_icon.1f6eba66.png";